/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { memo } from "react";
import "./RequestImageGallery.css";

const RequestImageGallery = memo(({ images, handleFileViewOpen }) => (
    <div className="request-image-gallery mt-2">
        {images?.length > 0 ? (
            images.map((image, index) => (
                <button
                    type="button"
                    key={index}
                    className="request-image-gallery__item"
                    onClick={() => handleFileViewOpen(index)}
                    aria-label={`View request image ${index + 1}`}
                >
                    <img
                        src={image?.ftm_request_image_path}
                        alt={`Request image ${index + 1}`}
                        className="request-image-gallery__image"
                        loading="lazy"
                    />
                </button>
            ))
        ) : (
            <p className="request-image-gallery__empty">This job has no images</p>
        )}
    </div>
));

export default RequestImageGallery;
